import { authFetch } from '../utils/authFetch';
import {baseUrl} from '../utils/requestUrl';

export const getCurrentUser = () => {
    try {
        const jwt = localStorage.getItem('accessToken');
        return jwt;
    } catch (ex) {
        return null;
    }
}


export const fetchProviders = async() => {
    const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id;
    const response = await authFetch(`${baseUrl}/careProviders/byOrganization/${organizationId}`);
    
    return response.json();
}

export const forgotPassword = async(email, resetUrl) => {
    const response = await fetch(`${baseUrl}/auth/forgot-password?email=${email}&resetUrl=${resetUrl}`,{
        method: 'POST',
    });
    
    if (!response.ok) {
        throw new Error('Failed to send reset password email');
    }
    
    return response.json();
}

export const resetPassword = async(token, password, confirmPassword) => {
    const response = await fetch(`${baseUrl}/auth/reset-password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            password: password,
            confirmPassword: confirmPassword
        })
    });
    
    if (!response.ok) {
        throw new Error(response?.message || 'Failed to reset password');
    }
    
    return response.json();
}


export const setPassword = async(token, password, confirmPassword) => {
    const response = await fetch(`${baseUrl}/auth/set-password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            password: password,
            confirmPassword: confirmPassword
        })
    });
    
    if (!response.ok) {
        throw new Error(response?.message || 'Failed to set password, try again!');
    }
    
    return response.json();
}

export const selectOrganization = async(organizationId) => {
    const response = await authFetch(`${baseUrl}/user/select-organization?organizationId=${organizationId}`, {
        method: 'POST'
    });

    if (!response.ok) {
        throw new Error('Failed to select organization');
    }

    return response.json();
}

export const setRole = async({roleType, roleName, id}) => {
    const response = await authFetch(`${baseUrl}/user/select-role?type=${roleType}&role=${roleName}&id=${id}`, {
        method: 'POST'
    });

    if (!response.ok) {
        throw new Error('Failed to set role');
    }

    return response.json();
}

export const changePassword = async(passwordData) => {
    const response = await authFetch(`${baseUrl}/auth/change-password`, {
        method: 'POST',
        body: JSON.stringify(passwordData),
    });
    
    return response.json();
}
